import type { Meta, StoryObj } from "@storybook/react";

import { SMTFoodTypeValue } from "@/constants/SMT";
import AddFoodTypeButtonBar from "@/ui/components/smt/food/AddFoodTypeButtonBar";
import type { AddFoodTypeButtonBarProps } from "@/ui/components/smt/food/AddFoodTypeButtonBar";
import { Box } from "@/ui/layout";

const AddFoodTypeButtonBarMeta: Meta<AddFoodTypeButtonBarProps> = {
  argTypes: {
    isNewFoodChecked: { control: "boolean" },
    onFoodTypePress: { action: "food type button pressed" },
    onNewFoodPress: { action: "new food button toggled states changed" },
    selectedFoodType: {
      control: "select",
      options: [undefined, ...Object.values(SMTFoodTypeValue)],
    },
  },
  component: AddFoodTypeButtonBar,
  render: (args) => (
    <Box width="100%">
      <AddFoodTypeButtonBar {...args} />
    </Box>
  ),
  title: "Components/Smt/Food/AddFoodTypeButtonBar",
};

type Story = StoryObj<AddFoodTypeButtonBarProps>;

const Primary: Story = {};

export { Primary };

export default AddFoodTypeButtonBarMeta;
